var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-holder"},[_c('b-form-input',{attrs:{"type":"date","value":_vm.selectedDate,"formatter":_vm.formatter},on:{"input":function($event){return _vm.updateValue($event)}}}),_c('i',{staticClass:"icon-close btn-clear",on:{"click":_vm.clear}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }